module.exports = __webpack_public_path__ + "static/media/VPN-APP.277411bd.png";